<template>
  <v-select
    v-model="localValue"
    variant="solo"
    menu-icon="mdi-chevron-down"
    clear-icon="mdi-close"
    class="ag-select"
    persistent-hint
    :hide-details="hideDetails"
    :hint="hint"
    :item-title="itemText"
    :item-value="itemValue"
    :items="items"
    :label="localLabel"
    :placeholder="placeholder"
    :disabled="disabled"
    :menu-props="{ bottom: true, offsetY: true }"
    :rules="rules"
    :data-message-color="messageColor"
    v-bind="$attrs"
  >
    <template v-if="labelDataQa" #label>
      <span :data-qa="normalizeQa(labelDataQa)">{{ localLabel }}</span>
    </template>
    <template #item="{ props, item }">
      <v-list-item v-bind="props" style="height: 64px" :disabled="item.raw.disabled" />
    </template>
  </v-select>
</template>

<script>
import { MESSAGE_COLOR } from '@/constants/ConstantMessageColor';
import UtilsString from '@/utils/UtilsString';
import { uniqueId } from 'lodash';

export default {
  emits: ['update:modelValue', 'change'],

  props: {
    id: {
      type: String,
      default: uniqueId('_agselect'),
    },

    label: {
      type: String,
      required: true,
    },

    labelDataQa: {
      type: String,
      default: undefined,
    },

    items: {
      type: Array,
      required: true,
    },

    itemText: {
      type: [String, Function],
      default: 'text',
    },

    itemValue: {
      type: [String, Function],
      default: 'value',
    },

    modelValue: {
      type: [Boolean, String, Number, Array, Object],
      default: null,
    },

    placeholder: {
      type: String,
      default: 'Selecione uma opção',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    rules: {
      type: Array,
      default: () => [],
    },

    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },

    hint: {
      type: String,
      default: undefined,
    },

    messageColor: {
      type: String,
      default: MESSAGE_COLOR.DEFAULT,
      validator: (val) => Object.values(MESSAGE_COLOR).includes(val),
    },
  },

  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
        this.$emit('change', val);
      },
    },

    campoObrigatorio() {
      return this.rules.some((rule) => rule?.name?.toLowerCase().includes('required'));
    },

    localLabel() {
      return `${this.label}${this.campoObrigatorio ? ' *' : ''}`;
    },
  },
  methods: {
    normalizeQa: UtilsString.normalizeQa,
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/input.scss';
@import '@/styles/select.scss';
</style>
